import DeletePlaylistConfirmModal from './DeletePlaylistConfirmModal'

export default DeletePlaylistConfirmModal
